import { maprange } from "../functions/maprange";

export function drawPoint(canvas, nodes, scale, width, height) {
    const ctx = canvas.getContext('2d')
    for (let i = 0; i < nodes.length; i++){
        const xrect = maprange(nodes[i][0], 0, scale, 0, width)
        const yrect = maprange(nodes[i][1], 0, (height/width)*scale, 0, height)
        //console.log(x)
        ctx.beginPath();
        ctx.fillStyle = '#49848'
        ctx.fillRect(xrect - 5, (height - yrect) - 5, 8, 8)
        ctx.fill()
        ctx.font = "17px Arial";
        ctx.fillText(i+1, xrect + 10, (height - yrect) + 20);
    }
}